<template>
  <section>
    <mdb-modal
      centered
      elegant
      scrollable
      size="lg"
      :show="mostrar"
      @close="mostrar = false, $emit('cerrar')"
    >
      <mdb-modal-header>
        <mdb-modal-title>Datos del despacho</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="row pt-0">
        <header class="col-12 h4-responsive detalle-despacho titulo mb-2">Fechas del despacho</header>
        <div class="col-12 col-sm-6">
          <mdb-input
            v-model="fechaSalida"
            type="date"
            label="Fecha de salida"
            class="my-1"
            outline
          />
        </div>
        <div class="col-12 col-sm-6">
          <mdb-input
            v-model="fechaRetorno"
            type="date"
            label="Fecha de retorno"
            class="my-1"
            outline
          />
        </div>
        <header class="col-12 h4-responsive detalle-despacho titulo mb-2">Personal encargado</header>
        <div class="col-12 col-sm-6 col-lg-4 mt-2">
          <div class="md-form md-outline outline-select my-1">
            <select
              :id="`select-vigilante-${identificador}`"
              v-model="vigilanteSeleccionado"
              class="custom-select"
            >
              <option class="d-none" disabled :value="{}">Seleccione</option>
              <option
                v-for="vigilante in vigilantes"
                :key="vigilante.id_per"
                :value="vigilante"
              >
                {{vigilante.nom_per}} {{vigilante.ape_per}}
              </option>
            </select>
            <label
              :for="`select-vigilante-${identificador}`"
              :class="Object.values(vigilanteSeleccionado).length
                ? 'label-active'
                : 'label-inactive'"
            >
              Vigilante
            </label>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-4 mt-2">
          <div class="md-form md-outline outline-select my-1">
            <select
              :id="`select-montacarguista-${identificador}`"
              v-model="montacarguistaSeleccionado"
              class="custom-select"
            >
              <option class="d-none" disabled :value="{}">Seleccione</option>
              <option
                v-for="montacarguista in montacarguistas"
                :key="montacarguista.id_per"
                :value="montacarguista"
              >
                {{montacarguista.nom_per}} {{montacarguista.ape_per}}
              </option>
            </select>
            <label
              :for="`select-montacarguista-${identificador}`"
              :class="Object.values(montacarguistaSeleccionado).length
                ? 'label-active'
                : 'label-inactive'"
            >
              Montacarguista
            </label>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-4 mt-2">
          <div class="md-form md-outline outline-select my-1">
            <select
              :id="`select-almacenista-${identificador}`"
              v-model="almacenistaSeleccionado"
              class="custom-select"
            >
              <option class="d-none" disabled :value="{}">Seleccione</option>
              <option
                v-for="almacenista in almacenistas"
                :key="almacenista.id_per"
                :value="almacenista"
              >
                {{almacenista.nom_per}} {{almacenista.ape_per}}
              </option>
            </select>
            <label
              :for="`select-almacenista-${identificador}`"
              :class="Object.values(almacenistaSeleccionado).length
                ? 'label-active'
                : 'label-inactive'"
            >
              Almacenista
            </label>
          </div>
        </div>
        <div class="col-12">
          <mdb-input
            label="Observaciones"
            v-model="observaciones"
            type="textarea"
            class="mt-2 mb-0 textarea-mb-0"
            outline
          />
        </div>
        <div class="col-12 documentos-des">
          <header class="h5-responsive documentos-titulo mb-2">Documentos</header>

          <ul v-if="documentosExistentes.length" class="documentos-lista">
            <li v-for="doc in documentosExistentes" :key="doc.id_desdoc" class="documento-item">
              <span class="documento-icono"><font-awesome-icon icon="file-pdf" /></span>
              <span class="documento-nombre">{{ doc.nom_desdoc || nombreArchivo(doc.ruta_desdoc) }}</span>
              <mdb-btn flat dark-waves icon="external-link-alt" size="sm" @click="verDocumento(doc.ruta_desdoc)">Ver</mdb-btn>
              <mdb-btn
                v-if="puedePrevisualizarRuta(doc.ruta_desdoc)"
                flat
                dark-waves
                icon="eye"
                size="sm"
                @click="alternarVistaPrevia('e-' + doc.id_desdoc)"
              >
                {{ previewActivo === 'e-' + doc.id_desdoc ? 'Ocultar' : 'Vista previa' }}
              </mdb-btn>
              <mdb-btn flat dark-waves icon="trash-alt" size="sm" @click="quitarDocumentoExistente(doc.id_desdoc)">Quitar</mdb-btn>
            </li>
          </ul>

          <div class="documentos-agregar">
            <label for="archivo" class="documentos-label">
              <font-awesome-icon icon="plus" /> Agregar documentos
            </label>
            <input
              type="file"
              id="archivo"
              class="documentos-input"
              multiple
              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif,.webp"
              @change="agregarDocumentos($event)"
            />
          </div>

          <ul v-if="documentosNuevos.length" class="documentos-lista mt-2">
            <li v-for="doc in documentosNuevos" :key="doc.key" class="documento-item nuevo">
              <span class="documento-icono"><font-awesome-icon icon="file-pdf" /></span>
              <span class="documento-nombre">{{ doc.file.name }}</span>
              <span class="documento-badge">Nuevo</span>
              <mdb-btn
                v-if="puedePrevisualizar(doc.file)"
                flat
                dark-waves
                icon="eye"
                size="sm"
                @click="alternarVistaPrevia('n-' + doc.key)"
              >
                {{ previewActivo === 'n-' + doc.key ? 'Ocultar' : 'Vista previa' }}
              </mdb-btn>
              <mdb-btn flat dark-waves icon="times" size="sm" @click="quitarDocumentoNuevo(doc.key)">Quitar</mdb-btn>
            </li>
          </ul>

          <div v-if="previewSrc" class="mt-3">
            <iframe :src="previewSrc" class="vista-previa" />
          </div>
        </div>
        <div class="col-12 d-flex justify-content-around mt-2">
          <mdb-btn
            flat
            dark-waves
            icon="times"
            @click="mostrar = false, $emit('cerrar')"
          >
            Cerrar
          </mdb-btn>
          <mdb-btn
            color="primario"
            :icon="notaDeEntrega ? 'check' :'sync'"
            @click="guardarDatos()"
          >
            {{notaDeEntrega ? 'Guardar' :'Actualizar'}}
          </mdb-btn>
        </div>
      </mdb-modal-body>
    </mdb-modal>
    <AlertaMensaje
      :alerta-mensaje="alertaMensaje"
      @cerrar="alertaMensaje.contenido = ''"
    />
  </section>
</template>
<script>
import {
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbInput
} from 'mdbvue'
import { apiPost } from '@/funciones/api.js'
import AlertaMensaje from '@/components/AlertaMensaje.vue'
import { esImagen, comprimirImagen } from '@/utils/imagenes.js'

export default {
  name: 'DatosDespacho',
  components: {
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    AlertaMensaje,
    mdbInput
  },
  props: {
    identificador: {
      type: [String, Number],
      required: true
    },
    modalDetallesDespacho: {
      type: Boolean,
      default: false
    },
    notaDeEntrega: {
      type: Boolean,
      default: false
    },
    vigilantes: {
      type: Array,
      default: () => []
    },
    montacarguistas: {
      type: Array,
      default: () => []
    },
    almacenistas: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      aggDatosPersonal: {},
      mostrar: false,
      fechaSalida: new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).substr(-2) + '-' + ('0' + (new Date().getDate())).substr(-2),
      fechaRetorno: '',
      vigilanteSeleccionado: {},
      montacarguistaSeleccionado: {},
      almacenistaSeleccionado: {},
      observaciones: '',
      alertaMensaje: { contenido: '' },
      documentosExistentes: [],
      documentosNuevos: [],
      previewActivo: '',
      nextKey: 0
    }
  },
  watch: {
    modalDetallesDespacho () {
      if (this.modalDetallesDespacho) {
        this.mostrar = true
        this.verDetallesDespacho()
      }
    },
    almacenistaSeleccionado () {
      this.modalDetallesDes()
    },
    mostrar () {
      if (!this.mostrar) {
        this.documentosNuevos.forEach((d) => URL.revokeObjectURL(d.previewUrl))
        this.documentosExistentes = []
        this.documentosNuevos = []
        this.previewActivo = ''
        this.nextKey = 0
        document.getElementById('archivo').value = ''
      }
    }
  },
  computed: {
    previewSrc () {
      if (!this.previewActivo) return ''
      if (this.previewActivo.startsWith('e-')) {
        const id = this.previewActivo.slice(2)
        const doc = this.documentosExistentes.find((d) => String(d.id_desdoc) === id)
        if (doc) return `${process.env.VUE_APP_FILES_URL}/${doc.ruta_desdoc}`
      }
      if (this.previewActivo.startsWith('n-')) {
        const key = this.previewActivo.slice(2)
        const doc = this.documentosNuevos.find((d) => d.key === key)
        if (doc) return doc.previewUrl
      }
      return ''
    }
  },
  methods: {
    async agregarDocumentos (event) {
      const files = Array.from(event.target.files)
      const permitidas = ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png', 'gif', 'webp']
      const rechazados = []
      for (const file of files) {
        const extension = file.name.split('.').pop().toLowerCase()
        if (!permitidas.includes(extension)) {
          rechazados.push(file.name)
          continue
        }
        const key = String(this.nextKey++)
        let archivoFinal = file
        if (esImagen(file)) {
          try {
            archivoFinal = await comprimirImagen(file)
          } catch (e) {
            archivoFinal = file
          }
        }
        this.documentosNuevos.push({
          key,
          file: archivoFinal,
          previewUrl: URL.createObjectURL(archivoFinal)
        })
      }
      if (rechazados.length) {
        this.alertaMensaje = {
          contenido: 'Solo se permiten archivos PDF, DOC, DOCX o imágenes (JPG, PNG, GIF, WEBP). Rechazados: ' + rechazados.join(', '),
          tipo: 'error'
        }
      }
      event.target.value = ''
    },
    quitarDocumentoNuevo (key) {
      const idx = this.documentosNuevos.findIndex((d) => d.key === key)
      if (idx !== -1) {
        URL.revokeObjectURL(this.documentosNuevos[idx].previewUrl)
        this.documentosNuevos.splice(idx, 1)
        if (this.previewActivo === 'n-' + key) this.previewActivo = ''
      }
    },
    quitarDocumentoExistente (id) {
      apiPost({ s: 'eliminarArchivo' }, 'tabla=despachos_documentos&id_col=id_desdoc&id_val=' + id + '&ruta_col=ruta_desdoc')
        .then((res) => {
          if (res.data.r) {
            this.documentosExistentes = this.documentosExistentes.filter((d) => d.id_desdoc !== id)
            if (this.previewActivo === 'e-' + id) this.previewActivo = ''
            this.alertaMensaje = {
              contenido: res.data.e || 'Documento eliminado correctamente',
              tipo: 'correcto'
            }
          } else {
            this.alertaMensaje = {
              contenido: res.data.e || 'Ha ocurrido un problema eliminando el documento',
              tipo: 'error'
            }
          }
        })
        .catch(() => {
          this.alertaMensaje = {
            contenido: 'Ha ocurrido un problema eliminando el documento',
            tipo: 'error'
          }
        })
    },
    verDocumento (ruta) {
      window.open(`${process.env.VUE_APP_FILES_URL}/${ruta}`, '_blank')
    },
    alternarVistaPrevia (key) {
      this.previewActivo = this.previewActivo === key ? '' : key
    },
    nombreArchivo (ruta) {
      return ruta.split('/').pop()
    },
    puedePrevisualizarRuta (ruta) {
      return /\.(pdf|jpe?g|png|gif|webp)$/i.test(ruta)
    },
    puedePrevisualizar (file) {
      return /\.(pdf|jpe?g|png|gif|webp)$/i.test(file.name)
    },
    verDetallesDespacho () {
      if (this.modalDetallesDespacho) {
        apiPost({ s: 'desEditallesMv' }, 'des=' + this.identificador)
          .then((res) => {
            res.data.desdet.forEach((p) => {
              this.fechaSalida = p.fec_des || new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).substr(-2) + '-' + ('0' + (new Date().getDate())).substr(-2)
              this.fechaRetorno = p.fec_ret_des || ''
              this.observaciones = p.obs_des || ''
              if (p.v_id_per) {
                this.vigilanteSeleccionado = {
                  id_per: p.v_id_per,
                  nom_per: p.v_nom_per,
                  ape_per: p.v_ape_per
                }
              } else if (this.vigilantes.length === 1) {
                this.vigilanteSeleccionado = this.vigilantes[0]
              }
              if (p.m_id_per) {
                this.montacarguistaSeleccionado = {
                  id_per: p.m_id_per,
                  nom_per: p.m_nom_per,
                  ape_per: p.m_ape_per
                }
              } else if (this.montacarguistas.length === 1) {
                this.montacarguistaSeleccionado = this.montacarguistas[0]
              }
              if (p.a_id_per) {
                this.almacenistaSeleccionado = {
                  id_per: p.a_id_per,
                  nom_per: p.a_nom_per,
                  ape_per: p.a_ape_per
                }
              } else if (this.almacenistas.length === 1) {
                this.almacenistaSeleccionado = this.almacenistas[0]
              }
            })
            this.documentosExistentes = res.data.desdocs || []
          })
      }
    },
    modalDetallesDes () {
      if (this.notaDeEntrega && this.vigilanteSeleccionado.id_per && this.fechaSalida && this.fechaRetorno && this.montacarguistaSeleccionado.id_per && this.almacenistaSeleccionado.id_per) {
        this.mostrar = false
        this.$emit('cerrar')
        this.abrirVentana()
        return
      }
      this.mostrar = this.modalDetallesDespacho
    },
    abrirVentana () {
      const routeData = this.$router.resolve({ name: 'NotaDeEntrega', params: { id: this.identificador } })
      window.open(routeData.href, '_blank')
    },
    guardarDatos () {
      if (!this.vigilanteSeleccionado.id_per || !this.fechaSalida || !this.fechaRetorno || !this.montacarguistaSeleccionado.id_per || !this.almacenistaSeleccionado.id_per) {
        this.alertaMensaje = {
          contenido: 'Debes rellenar todos los datos',
          tipo: 'error'
        }
        return
      }
      apiPost({ s: 'datosDes' }, 'des=' + this.identificador + '&ret=' + this.fechaRetorno + '&sa=' + this.fechaSalida + '&al=' + this.almacenistaSeleccionado.id_per + '&mon=' + this.montacarguistaSeleccionado.id_per + '&vi=' + this.vigilanteSeleccionado.id_per + '&obs=' + this.observaciones)
        .then((res) => {
          if (res.data.r) {
            if (this.documentosNuevos.length) {
              this.subirDocumentosNuevos()
            } else {
              this.despuesDeGuardar()
            }
          } else {
            this.alertaMensaje = {
              contenido: 'Ha ocurrido un problema guardando los datos',
              tipo: 'error'
            }
          }
        })
    },
    subirDocumentosNuevos () {
      const formData = new FormData()
      this.documentosNuevos.forEach((d) => formData.append('archivo[]', d.file))
      formData.append('tabla', 'despachos_documentos')
      formData.append('id_fk_col', 'id_des')
      formData.append('id_fk_val', this.identificador)
      formData.append('ruta_col', 'ruta_desdoc')
      formData.append('nom_col', 'nom_desdoc')
      formData.append('carpeta', 'despachos')
      apiPost({ s: 'subirArchivos' }, formData)
        .then((res) => {
          if (res.data.r) {
            this.documentosNuevos.forEach((d) => URL.revokeObjectURL(d.previewUrl))
            this.documentosNuevos = []
            this.previewActivo = ''
            this.alertaMensaje = {
              contenido: 'Se han guardado los datos',
              tipo: 'correcto'
            }
            this.despuesDeGuardar()
          } else {
            this.alertaMensaje = {
              contenido: res.data.e || 'Ha ocurrido un problema subiendo los archivos',
              tipo: 'error'
            }
          }
        })
        .catch(() => {
          this.alertaMensaje = {
            contenido: 'Ha ocurrido un problema subiendo los archivos',
            tipo: 'error'
          }
        })
    },
    despuesDeGuardar () {
      this.aggDatos = false
      this.verDetallesDespacho(this.identificador)
      this.$emit('actualizar')
      if (this.notaDeEntrega) {
        this.abrirVentana()
      }
      this.mostrar = false
      this.$emit('cerrar')
    }
  },
  mounted () {
    this.verDetallesDespacho()
  }
}
</script>

<style lang="scss" scoped>
  .documentos-des {
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 0.375rem;
    padding: 0.75rem 1rem 1rem;
    margin-top: 0.75rem;
  }

  .documentos-titulo {
    color: #495057;
    font-weight: 600;
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 0.4rem;
  }

  .documentos-lista {
    list-style: none;
    padding: 0;
    margin: 0 0 0.5rem;
  }

  .documento-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background-color: #ffffff;
    border: 1px solid #e9ecef;
    border-radius: 0.25rem;
    padding: 0.4rem 0.6rem;
    margin-bottom: 0.4rem;

    &.nuevo {
      border-color: #D92026;
      background-color: #fff5f5;
    }
  }

  .documento-icono {
    color: #D92026;
    font-size: 1rem;
  }

  .documento-nombre {
    flex: 1;
    font-size: 0.85rem;
    color: #343a40;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .documento-badge {
    font-size: 0.7rem;
    color: #fff;
    background-color: #D92026;
    border-radius: 0.25rem;
    padding: 0.1rem 0.4rem;
  }

  .documentos-agregar {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .documentos-label {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    background-color: #D92026;
    color: #ffffff;
    font-size: 0.85rem;
    padding: 0.4rem 0.85rem;
    border-radius: 0.25rem;
    cursor: pointer;
    white-space: nowrap;

    &:hover { background-color: #b8181d; }
  }

  .documentos-input {
    flex: 1;
    font-size: 0.8rem;
    color: transparent;

    &::-webkit-file-upload-button {
      visibility: hidden;
    }
  }

  .vista-previa {
    width: 100%;
    height: 400px;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    background-color: #ffffff;
  }
</style>
